import Vue from 'vue';
import randomstring from 'randomstring';
import ValidatorHelper from 'viralstyle-ui/src/ValidatorHelper';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import find from 'lodash/find';
import each from 'lodash/each';
import remove from 'lodash/remove';
import size from 'lodash/size';

import CustomVar from 'domains/base/store/model';
import CampaignsCollection from './collection';

export const state = {
  campaigns: {
    all: new CampaignsCollection('all'),
    draft: new CampaignsCollection('draft', [], 0),
    store: new CampaignsCollection('store'),
    promotable: new CampaignsCollection('promotable'),
  },
  displayType: 'list',
  relaunchBasePrice: 0,
  campaignCategories: [],
  currentCampaign: {
    cache: {}, //maybe rename this
    info: {},
    upsellData: {},
    eligibleUpsells: new CampaignsCollection(),
    products: [],
    firstProductsWithColors: [],
    defaultProduct: {},
    eligibleProducts: [],
    addedEligibleProducts: [],
    pixels: {},
    googleAnalytics: null,
    seo: {},
    email: {},
    assets: [],
    'ad-factory': null,
    analyticsCampaignId: null,
    analyticsRelaunchSelection: 'All Time',
  },
  original: {
    info: null,
    pixels: null,
    seo: null,
    emailId: null,
  },
  maxProductVariants: 50,
  maxColorsPerProduct: 10,
  aggregations: {
    regionalVisitors: {},
    visitors: [],
    heatmap: {},
    visitorDevices: {},
    visitorReferrals: {},
    referrers: [],
    products: {},
    upsellStats: [],
    loading: {
      visitors: false,
      geoVisitors: false,
      devices: false,
      referrals: false,
      utm: false,
      products: false,
      upsells: false,
    },
  },
  campaignsAggregations: {
    visitors: [],
  },
  relaunchHistory: [],
  productTypes: {},
  emailRepDetails: {},
  previousCampaignStatusFilter: 'All',
};

export const mutations = {
  setCampaigns(state, { type, response }) {
    state.campaigns[type].campaigns = [...state.campaigns[type].campaigns, ...response.data._embedded.items]
    state.campaigns[type].initialized = true;
    state.campaigns[type].total = response.data.total_results;

    if (response.data._embedded.items.length === state.campaigns[type].limit) {
      state.campaigns[type].page++;
      state.campaigns[type].canLoad = true;
    } else {
      state.campaigns[type].canLoad = false;
    }
  },

  updateCampaignsCollection(state, { type, property, value }) {
    state.campaigns[type][property] = value;
    state.campaigns[type].campaigns = [];
    state.campaigns[type].page = 0;
    state.campaigns[type].canLoad = true;
    state.campaigns[type].initialized = false;
  },

  resetCampaigns(state, type) {
    state.campaigns[type].campaigns = [];
    state.campaigns[type].page = 0;
    state.campaigns[type].canLoad = true;
    state.campaigns[type].initialized = false;

    if (type === 'all') {
      state.campaignsAggregations.visitors = [];
    }
  },

  updateCurrentCampaign(state, { property, value, tab }) {
    set(state.currentCampaign[tab], property, value);
  },

  setCurrentCampaign(state, { property, value, tab }) {
    set(state.currentCampaign, property, value);

    switch (tab) {
      case 'info':
        Vue.set(state.currentCampaign.info, 'x_sell_tag_id', state.currentCampaign.info.x_sell_tag ? state.currentCampaign.info.x_sell_tag.id : null);
        state.original.info = cloneDeep(state.currentCampaign.info);
        break;
      case 'upsells':
        each(state.currentCampaign.upsellData.upsells, upsell => {
          upsell.dirty = false;
          upsell.validator = new ValidatorHelper();
        });
        break;
      case 'products':
        each(state.currentCampaign.products, products => {
          let defaultProduct = find(products, product => product.is_default && !product.is_discontinued && product.is_active);

          if (defaultProduct) {
            state.currentCampaign.defaultProduct = defaultProduct;
            return false;
          }
        });

        if (size(state.currentCampaign.products) && !size(state.currentCampaign.defaultProduct)) {
          each(state.currentCampaign.products, products => {
            let defaultProduct = find(products, product => !product.is_discontinued && product.is_active);

            if (defaultProduct) {
              state.currentCampaign.defaultProduct = defaultProduct;
              return false;
            }
          });
        }

        break;
      case 'tracking':
        break;
      case 'meta':
        let name = state.currentCampaign.info.name,
          description = state.currentCampaign.info.description ? state.currentCampaign.info.description.replace(/<[^>]+>/gm, ' ').replace(/\s{2,}/g, ' ').replace('&nbsp;', ' ').trim() : '',
          vsMeta = state.currentCampaign.seo.viralstyle,
          fbMeta = state.currentCampaign.seo.open_graph,
          twitterMeta = state.currentCampaign.seo.twitter;

        if (!vsMeta.title) vsMeta.title = name;
        if (!vsMeta.description) vsMeta.description = description;
        if (!twitterMeta.title) twitterMeta.title = name;
        if (!twitterMeta.description) twitterMeta.description = description;
        if (!fbMeta.title) fbMeta.title = name;
        if (!fbMeta.description) fbMeta.description = description;

        state.original.seo = cloneDeep(state.currentCampaign.seo);
        break;
      case 'email':
        state.original.emailId = cloneDeep(state.currentCampaign.email.id);
        break;
      case 'assets':
        break;
    }
  },

  buildFirstProductsWithColors(state) {
    let firstProductsWithColors = [],
      firstProduct = {};

    each(state.currentCampaign.products, (products, key) => {
      let addedProduct = find(state.currentCampaign.addedEligibleProducts, addedEligibleProduct => addedEligibleProduct.id === key);

      firstProduct = cloneDeep(find(products, product => {
        if (product.type_id === state.currentCampaign.defaultProduct.type_id) {
          return product.color.id === state.currentCampaign.defaultProduct.color.id;
        } else {
          return product.color.active;
        }
      }));

      if (addedProduct) {
        Vue.set(firstProduct, 'colors', addedProduct.colors);
      } else {
        Vue.set(firstProduct, 'colors', [{ ...firstProduct.color, created: true }]);
      }

      Vue.set(firstProduct, 'dirty', false);
      Vue.set(firstProduct, 'isNew', false);

      firstProductsWithColors.push(firstProduct);
    });

    state.currentCampaign.firstProductsWithColors = firstProductsWithColors;
  },

  setCurrentCampaignProducts(state, products) {
    state.currentCampaign.addedEligibleProducts = remove(products, product => find(product.colors, color => color.created));
    state.currentCampaign.eligibleProducts = products;

    mutations.buildFirstProductsWithColors(state);
  },

  updateCurrentCampaignUpsell(state, { upsell, property, value }) {
    upsell[property] = value;
    upsell.isNew = false;
  },

  setCampaignCategories(state, categories) {
    state.campaignCategories = categories;
  },

  setEligibleUpsells(state, upsells) {
    state.currentCampaign.eligibleUpsells.campaigns = [...state.currentCampaign.eligibleUpsells.campaigns, ...upsells._embedded.items];
    state.currentCampaign.eligibleUpsells.initialized = true;

    if (upsells._embedded.items.length === state.currentCampaign.eligibleUpsells.limit) {
      state.currentCampaign.eligibleUpsells.page++;
      state.currentCampaign.eligibleUpsells.canLoad = true;
    } else {
      state.currentCampaign.eligibleUpsells.canLoad = false;
    }
  },

  resetEligibleUpsells(state) {
    state.currentCampaign.eligibleUpsells.campaigns = [];
    state.currentCampaign.eligibleUpsells.page = 0;
    state.currentCampaign.eligibleUpsells.canLoad = true;
    state.currentCampaign.eligibleUpsells.initialized = false
  },

  setRelaunchBasePrice(state, price) {
    state.relaunchBasePrice = price;
  },

  initializeCurrentCampaignFacebookCustomVars(state) {
    if (!Object.keys(state.currentCampaign.pixels.facebook.custom_vars).length) Vue.set(state.currentCampaign.pixels.facebook, 'custom_vars', {})

    let custom_vars = state.currentCampaign.pixels.facebook.custom_vars;

    each(custom_vars, customVars => each(customVars, type => type.symbol = randomstring.generate()));

    mutations.initVarType(custom_vars, 'VIEW_CONTENT');
    mutations.initVarType(custom_vars, 'ADD_TO_CART');
    mutations.initVarType(custom_vars, 'INITIATE_CHECKOUT');
    mutations.initVarType(custom_vars, 'PURCHASE');

    state.original.pixels = cloneDeep(state.currentCampaign.pixels);
  },

  initVarType(vars, type) {
    vars[type] ? vars[type].push(new CustomVar(type)) : Vue.set(vars, type, [new CustomVar(type)]);
  },

  removeCurrentCampaignFacebookCustomVar(state, { index, type }) {
    state.currentCampaign.pixels.facebook.custom_vars[type].splice(index, 1);
  },

  updateCurrentCampaignFacebookCustomVar(state, { index, property, value, type }) {
    state.currentCampaign.pixels.facebook.custom_vars[type][index][property] = value;

    let customVars = state.currentCampaign.pixels.facebook.custom_vars[type],
      customVar = customVars[index],
      lastVar = customVars[customVars.length - 1],
      previousVar;

    if (customVars.length > 1) previousVar = customVars[customVars.length - 2];

    // if: add new custom var if last var has key and value
    // else if: remove last custom var if previous var has key or value removed
    if (lastVar.key && lastVar.value) {
      customVars.push(new CustomVar(type));
    } else if (previousVar && (!previousVar.key || !previousVar.value)) {
      customVars.pop();
    }

    // remove custom var if its not the last one and its empty
    if (index !== customVars.length - 1 && !customVar.key && !customVar.value) {
      customVars.splice(index, 1);
    }
  },

  resetChartsData(state) {
    state.aggregations.regionalVisitors = {};
    state.aggregations.visitors = {};
    state.aggregations.heatmap = {};
    state.aggregations.visitorDevices = {};
    state.aggregations.visitorReferrals = {};
    state.aggregations.referrers = [];
    state.aggregations.products = {};
    state.aggregations.upsellStats = [];
  },

  setCampaignsChartsData(state, visitors) {
    state.campaignsAggregations.visitors = visitors;
  },

  setEmailRepDetails(state, details) {
    state.emailRepDetails = details;
  },
};